import { TravelRequestTableColumns } from "@bonliva-crm/shared";
import { useMemo } from "react";
import locale from "@bonliva-crm/locale";

const defaultColumns: TravelRequestTableColumns[] = Object.values(
  TravelRequestTableColumns
);

export function useColumnNameSelector() {
  const columnNameSelector = useMemo(() => {
    return {
      localStorageName: "travelRequestSearchColumns",
      defaultColumns: defaultColumns.map((value) => ({
        label: locale.travelRequestTableColumns[value],
        value: value
      }))
    };
  }, []);

  return columnNameSelector;
}
